export const ME_SESSION_STORAGE_KEYS = {
    declarationOfConsent: 'ow_aem_enableDataUsages',
    dataUsageScopes: 'ow_aem_dataUsageScopes',
    dataUsageScopesTimeStamp: 'ow_aem_dataUsageScopes_timestamp',
    dataUsageScopesTimeStampFailed: 'ow_aem_dataUsageScopes_timestamp_failed',
    dataUsageScopesIdentity: 'ow_aem_dataUsageScopes_identity'
};